import gql from "graphql-tag";

export const pedestrianAccessEventsQuery = gql`
  query PedestrianAccessEvents($from: DateTime!, $to: DateTime!) {
    pedestrianAccessEvents(from: $from, to: $to) {
      id
      createdAt
      gateId
      gateDescription
      doorId
      sourceType
      sourceId
      controllerGranted
      outcome
      reason
      eventId
    }
  }
`;
